module.exports = __webpack_public_path__ + "static/media/question-mark.3a130a19.svg";